import { atom } from "jotai";

export const allSettings = atom({});
